import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-y border-slate-900/10 bg-stone-100" data-id="element-274" data-mp="1tai2pb8gatrc">
      <div className="mx-auto max-w-6xl px-8 py-14 sm:px-14 lg:flex lg:items-center lg:gap-12" data-id="element-275" data-mp="1t8dqm60eeofz">
        <h2 className="shrink-0 font-serif text-2xl italic leading-tight text-red-700 lg:w-44" data-id="element-276" data-mp="1odhy74r91z2c">
          一套完整教材，數字說明一切
        </h2>
        <dl className="mt-8 grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-3 lg:mt-0 lg:flex-1 lg:grid-cols-5" data-id="element-277" data-mp="1ecz83s93dmbz">
          {stats.map(stat => <div key={stat.label} className="flex flex-col-reverse border-l border-slate-900/15 pl-5" data-id="element-278" data-mp="19lg09q8qpg4y">
              <dt className="mt-3 text-sm leading-snug text-slate-900/70" data-id="element-279" data-mp="15lp4t989qbu3">{stat.label}</dt>
              <dd className="font-serif text-6xl leading-none tracking-tight text-slate-900" data-id="element-280" data-mp="10mvoza5ie8qr">
                {stat.value}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}